import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'
import './src/styles/index.scss'
import wraperPage from './plugin/wraperPage'
import wraperRoot from './plugin/wraperRoot'

export const wrapRootElement = wraperRoot
export const wrapPageElement = wraperPage
